export default "__VITE_ASSET__d89252b4__"